const routes = {
  login: "/login",
  dashboards: "/",
  search: "/search",

  // Рабочие группы
  units: "/units",
  unitTasks: (id) => `/units/${id}/u-tasks/u-tasks-list`,
  unitTaskDetail: (unit, id) => `/units/${unit}/u-tasks/u-tasks-list/${id}`,
  unitTaskTemplates: (id) => `/units/${id}/u-tasks/u-tasks-templates`,
  unitTaskTemplateDetail: (unit, id) =>
    `/units/${unit}/u-tasks/u-tasks-templates/${id}`,
  unitFolder: (unit, id = "catalog") => `/units/${unit}/u-files/${id}`,
  unitObjectList: (unit, def_id) => `/units/${unit}/u-objects/${def_id}`,
  unitObjectDetail: (unit, def_id, id) =>
    `/units/${unit}/u-objects/${def_id}/${id}`,
  unitObjectNew: (unit, def_id) => `/units/${unit}/u-objects/${def_id}/new`,
  unitMembers: (id) => `/units/${id}/u-members`,
  unitCalendar: (id, params) => {
    const searchParams = new URLSearchParams(params).toString();
    return `/units/${id}/u-calendar?${searchParams}`;
  },
  unitSprints: (id) => `/units/${id}/u-sprints`,
  unitSprintDetail: (unit, id) => `/units/${unit}/u-sprints/${id}`,

  // Задачи
  tasks: "/tasks/t-list",
  taskDetail: (id) => `/tasks/t-list/${id}`,

  // Шаблоны задач
  taskTemplates: "/tasks/t-templates",
  taskTemplateDetail: (id) => `/tasks/t-templates/${id}`,

  // Календарь
  calendar: (params) => {
    const searchParams = new URLSearchParams(params).toString();
    return `/calendar?${searchParams}`;
  },

  // Спринты
  sprints: "/sprints",
  sprintDetail: (id) => `/sprints/${id}`,

  // Заявки
  requestRegistration: (type) => `/request-registration/${type}`,
  requestForm: (type, unit, isPublic = false) =>
    isPublic
      ? `/request-form/${type}/${unit}`
      : `/in-request-form/${type}/${unit}`,

  // Мои заявки
  myRequests: "/my-requests",
  myRequestDetail: (id) => `/my-requests/${id}`,
  requestEntry: (id) => `/request-entry/${id}`,

  // Файлы (Каталог файлов)
  folder: (id = "catalog") => "/files/" + id,

  // Ресурсы (Недвижимость)
  objectList: (def_id) => `/my-objects/${def_id}`,
  objectDetail: (def_id, id) => `/my-objects/${def_id}/${id}`,
  objectNew: (def_id) => `/my-objects/${def_id}/new`,

  // Карта с ресурсами
  mapView: "/map-view",

  // Структура компании
  companyStructure: "/company-structure",

  // Отчеты
  reportView: (uuid) => `/custom-reports/${uuid}`,

  // Профиль
  profile: "/profile",
  // Уведомления
  notices: (tab) => `/notices/${tab}`,

  // Администрирование
  administration: {
    search: "/administration/search",
    employeeList: "/administration/employees/e-list",
    employeeDetail: (id) => `/administration/employees/e-list/${id}`,
    timeTracking: "/administration/employees/time-tracking",

    guides: {
      positions: "/administration/guides/positions",
      priorities: "/administration/guides/priorities",
      statuses: "/administration/guides/statuses",
      unitTypes: "/administration/guides/unit-types",
      tags: "/administration/guides/tags",
      tagDetail: (id) => `/administration/guides/tags/${id}`,
      taskTypes: "/administration/guides/task-types",
      sprintStatuses: "/administration/guides/sprint-statuses",
    },
    users: "/administration/users",
    userDetail: (uuid) => `/administration/users/${uuid}`,
    tasks: "/administration/all-tasks/all-t-list",
    taskDetail: (id) => `/administration/all-tasks/all-t-list/${id}`,
    taskTemplates: "/administration/all-tasks/all-t-templates",
    taskTemplateDetail: (id) =>
      `/administration/all-tasks/all-t-templates/${id}`,
    units: "/administration/all-units",
    unitDetail: (id) => `/administration/all-units/admin-${id}`,
    resourcesSettings: {
      structures: {
        definitions: (type) => `/administration/resources/structures/${type}`,
        definitionDetail: (type, id) =>
          `/administration/resources/structures/${type}/${id}`,

        definitionSettingObjectForm: (type, id) =>
          `/administration/resources/structures/${type}/${id}/setting-object-form`,
        definitionSettingTabularForm: (type, id) =>
          `/administration/resources/structures/${type}/${id}/setting-table-form`,
        definitionSettingFilters: (type, id) =>
          `/administration/resources/structures/${type}/${id}/setting-filters`,
      },
    },
    objectList: (def_id) => `/administration/all-objects/${def_id}`,
    objectDetail: (def_id, id) => `/administration/all-objects/${def_id}/${id}`,
    objectNew: (def_id) => `/administration/all-objects/${def_id}/new`,
    folder: (id = "catalog") => "/administration/all-files/" + id,
    systemSettings: "/administration/system-settings",
    NSPDSettings: "/administration/nspd-settings",
    systemLogging: "/administration/system-logging",
    noticeSettings: "/administration/notice-settings",
    reportSettings: (id = "new") =>
      `/administration/system-settings/reports/${id}`,
    requestSettings: (id = "new") =>
      `/administration/system-settings/requests/${id}`,
    requestPreview: (uuid = "new", id = "default") =>
      `/administration/system-settings/requests-preview/${uuid}/${id}`,
    sprints: "/administration/all-sprints",
    sprintDetail: (id) => `/administration/all-sprints/${id}`,
  },
};

export default routes;
